'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('zoning_updates', {
      url: '/account/zoning_updates?jurisdiction&sta_recid',
      template: '<zoning-updates></zoning-updates>',
      authenticate: true,
      params: {
        jurisdiction: null,
        sta_recid: null      
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/zoning_updates/zoning_updates.routes.js